import { render } from "./BookingLoader.vue?vue&type=template&id=c50796d6"
import script from "./BookingLoader.vue?vue&type=script&lang=js"
export * from "./BookingLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__